/* RNG — Frequently bought together.
   Each row is a real variant with its own name, picture and price. Products with several
   variants get a picker; "This item" follows the variant chosen on the product page. */
(() => {
  const el = document.querySelector('[data-rng-fbt-v2]');
  const dataEl = document.querySelector('[data-rng-fbt-product]');
  if (!el || !dataEl || el.dataset.ready) return;
  el.dataset.ready = '1';

  let P, C = {};
  try { P = JSON.parse(dataEl.textContent); } catch (e) { return; }
  try { C = JSON.parse((document.getElementById('rng-config') || {}).textContent || '{}'); } catch (e) {}
  const F = Object.assign({ enabled: true, count: 2, heading: 'Frequently bought together', button: 'Add selected to cart', total: 'Total:', thisItem: 'This item:' }, C.fbt || {});
  if (!F.enabled) return;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');
  const isDefault = (t) => !t || /^default title$/i.test(t);
  function money(cents) {
    const n = Number(cents || 0) / 100;
    const group = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const [i, d] = n.toFixed(2).split('.');
    return (C.moneyFormat || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return group(String(Math.round(n)), ',');
      if (k === 'amount_with_comma_separator') return group(i, '.') + ',' + d;
      if (k === 'amount_no_decimals_with_comma_separator') return group(String(Math.round(n)), '.');
      return group(i, ',') + '.' + d;
    });
  }

  async function recs(limit) {
    for (const intent of ['complementary', 'related']) {
      try {
        const r = await fetch(`${root}recommendations/products.json?product_id=${P.id}&limit=${limit}&intent=${intent}`);
        if (!r.ok) continue;
        const j = await r.json();
        if (j.products && j.products.length) return j.products;
      } catch (e) {}
    }
    return [];
  }

  const pick = (vs, id) => vs.find((v) => v.id === id && v.available) || vs.find((v) => v.id === id) || vs.find((v) => v.available) || vs[0];
  const vUrl = (it) => it.url + (it.url.includes('?') ? '&' : '?') + 'variant=' + it.variant.id;
  const label = (it, v) => (isDefault(v.title) ? '' : v.title);

  (async () => {
    const list = (await recs(Number(F.count) + 4))
      .filter((p) => p.id !== P.id && p.variants.some((v) => v.available))
      .slice(0, Number(F.count) || 2);
    if (!list.length) return;

    const mainVariants = P.variants.map((v) => ({ id: v.id, title: v.title, price: v.price, available: v.available, image: v.image || P.image }));
    const formVariant = () => {
      const inp = document.querySelector('product-info form[action*="/cart/add"] [name="id"], form[id^="product-form-template"] [name="id"]');
      return inp ? Number(inp.value) : P.selected;
    };
    const main = { main: true, title: P.title, url: P.url, variants: mainVariants };
    main.variant = pick(mainVariants, formVariant());

    const items = [main].concat(list.map((p) => {
      const fallback = p.featured_image ? sized(p.featured_image, 200) : '';
      const variants = p.variants.map((v) => ({
        id: v.id, title: v.title, price: v.price, available: v.available,
        image: (v.featured_image && v.featured_image.src) ? sized(v.featured_image.src, 200) : fallback,
      }));
      return { title: p.title, url: p.url, variants, variant: pick(variants) };
    }));
    const on = items.map((it) => !!it.variant.available);

    const name = (it) => {
      const v = label(it, it.variant);
      return esc(it.title) + (it.variants.length > 1 && v ? ` <span class="rng-fbt__variant">${esc(v)}</span>` : '');
    };
    const picker = (it, i) => {
      if (it.main || it.variants.length < 2) return '';
      return `<select class="rng-fbt__select" data-v="${i}" aria-label="${esc(it.title)} – choose an option">${it.variants.map((v) =>
        `<option value="${v.id}"${v.id === it.variant.id ? ' selected' : ''}${v.available ? '' : ' disabled'}>${esc(label(it, v) || it.title)} · ${v.available ? money(v.price) : 'Sold out'}</option>`).join('')}</select>`;
    };
    const chosen = () => items.filter((it, i) => on[i] && it.variant.available);

    function draw() {
      el.innerHTML = `<h3 class="rng-fbt__title h4">${esc(F.heading)}</h3>
        <div class="rng-fbt__imgs">${items.map((it, i) => {
          const alt = it.title + (label(it, it.variant) ? ' – ' + label(it, it.variant) : '');
          return `${i ? '<span class="rng-fbt__plus" aria-hidden="true">+</span>' : ''}<a href="${esc(vUrl(it))}"${on[i] ? '' : ' class="is-off"'}>${it.variant.image ? `<img src="${esc(it.variant.image)}" alt="${esc(alt)}" width="88" height="88" loading="lazy">` : `<span class="rng-fbt__noimg">${esc(it.title)}</span>`}</a>`;
        }).join('')}</div>
        <ul class="rng-fbt__list">${items.map((it, i) => `<li><label><input type="checkbox" data-i="${i}"${it.variant.available ? (on[i] ? ' checked' : '') : ' disabled'}><span class="rng-fbt__name">${it.main ? `<em>${esc(F.thisItem)}</em> ` : ''}${name(it)}</span><span class="rng-fbt__price">${it.variant.available ? money(it.variant.price) : 'Sold out'}</span></label>${picker(it, i)}</li>`).join('')}</ul>
        <div class="rng-fbt__foot"><span>${esc(F.total)} <strong data-total></strong></span><button type="button" class="button rng-fbt__btn">${esc(F.button)}</button></div>`;
      const sel = chosen();
      el.querySelector('[data-total]').textContent = money(sel.reduce((s, it) => s + it.variant.price, 0));
      el.querySelector('.rng-fbt__btn').disabled = !sel.length;
    }

    el.addEventListener('change', (e) => {
      const t = e.target;
      if (t.matches('input[data-i]')) { on[Number(t.dataset.i)] = t.checked; draw(); }
      else if (t.matches('select[data-v]')) {
        const i = Number(t.dataset.v);
        items[i].variant = pick(items[i].variants, Number(t.value));
        on[i] = items[i].variant.available;
        draw();
        const s = el.querySelector(`select[data-v="${i}"]`);
        if (s) s.focus();
      }
    });
    el.addEventListener('click', async (e) => {
      const btn = e.target.closest('.rng-fbt__btn');
      if (!btn) return;
      const sel = chosen();
      if (!sel.length) return;
      const text = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';
      try {
        const r = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: sel.map((it) => ({ id: it.variant.id, quantity: 1 })) }) });
        const j = await r.json();
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
        btn.textContent = 'Added ✓';
        setTimeout(() => { btn.textContent = text; btn.disabled = false; }, 1600);
        return;
      } catch (err) {
        btn.textContent = text;
        btn.disabled = false;
        window.alert(err.message);
      }
    });

    // Keep "This item" in sync with the variant chosen on the page.
    const sync = (id) => {
      if (!id || id === main.variant.id) return;
      main.variant = pick(mainVariants, Number(id));
      on[0] = main.variant.available;
      draw();
    };
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (ev) => { const v = ev && ev.data && ev.data.variant; if (v) sync(v.id); });
    }
    document.addEventListener('change', (e) => { if (e.target.closest('variant-selects, variant-radios')) setTimeout(() => sync(formVariant()), 60); });

    draw();
    el.hidden = false;
  })();
})();
